export enum GroupQuoteStatus {
  NOT_AVAILABLE = "NOT_AVAILABLE",
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}
